<template>
  <div id="employee-detail">
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <b-row v-if="employee_detail">
        <b-col md="6">
          <div class="d-flex align-items-center">
            <img
              class="back-to-list-apps m__t--20"
              src="@/assets/icon/arrow-left.svg"
              @click="$router.push('/administrator')"
            >
            <div
              v-if="employee_detail"
              class="d-flex align-items-center justify-content-between m--10">
              <div class="d-flex align-items-center">
                <div class="m__r--10">
                  <b-img
                    v-if="employee_detail.photo_url"
                    :src="employee_detail.photo_url"
                    rounded="circle"
                    alt="img"
                    class="img-employee"/>
                  <b-img
                    v-else
                    :src="require('../../assets/logo/user1.png')"
                    rounded="circle"
                    alt="img"
                    class="img-employee"/>
                </div>
                <div>
                  <h6 class="font-weight-bold m__b--0">
                    {{ employee_detail.first_name }} {{ employee_detail.last_name }}
                  </h6>
                  <span> {{ employee_detail.email }} </span>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="6">
          <i
            id="configPopover"
            class="fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--10"/>
        </b-col>
      </b-row>

      <!-- tab menu on header -->
      <div class="d-flex m__t--2">

        <div
          v-for="tab in tabOptions"
          :key="tab.id"
        >
          <div
            v-if="tab.isShow"
            :class="{'tab-experience-manager-active' : tabSelected === tab.id}"
            class="tab-experience-manager m__r--35"
            @click="tabSelected = tab.id">
            {{ tab.title }}
          </div>
        </div>
      </div>
    </div>

    <b-popover
      v-if="employee_detail"
      ref="configPopoverRef"
      :show.sync="configPopoverShow"
      target="configPopover"
      container="employee-detail"
      placement="left">
      <div
        class="user-config-opt"
        @click="openModalchangePassword">
        Change Password
      </div>
      <div
        class="user-config-opt"
        @click="deletedEmployee">
        Delete
      </div>
    </b-popover>

    <b-modal
      ref="changePasswordModal"
      class="mod-form modal-change-password"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h3
        class="modal-title"
        style="color: #9A9A9A !important">
        CHANGE PASSWORD
      </h3>

      <b-form>
        <b-form-group
          id="password-input"
          :class="{'error-input' : $v.form.password.$error || isNotStrenghtPassword}">
          <label> Password </label>
          <j-input
            v-model="form.password"
            :max-length="50"
            :type="passwordType"
            :error-required="$v.form.password.$error"
            :error-message="'Field is required'"

            placeholder="Type new password"/>
          <label class="showhide">
            <i
              :class="{'fa fa-eye': !showPassword, 'fa fa-eye-slash': showPassword,
                       'eye-error' : $v.form.password.$error || isNotStrenghtPassword}"
              @click="showPassword=!showPassword"/>
          </label>
        </b-form-group>
        <PasswordChecker
          ref="passwordChecker"
          :data="passwordCheckerData"
          class="my-1" />
        <b-form-group
          id="confirm-password-input"
          :class="{'error-input' : $v.form.confirm_password.$error}">
          <label> Confirm Password </label>
          <j-input
            v-model="form.confirm_password"
            :max-length="50"
            :error-message="confirmErrmessage"
            :type="confirmPasswordType"
            placeholder="Type confirm password"/>
          <label class="showhide">
            <i
              :class="{'fa fa-eye': !showConfirmPassword, 'fa fa-eye-slash': showConfirmPassword,
                       'eye-error' : $v.form.confirm_password.$error}"
              @click="showConfirmPassword=!showConfirmPassword"/>
          </label>
        </b-form-group>
      </b-form>

      <div class="float-right m__t--20">
        <b-button
          class="btn m__r--5"
          @click="closeModalchangePassword">
          Close
        </b-button>
        <b-button
          class="btn blue"
          @click="updatePassword">
          Confirm
        </b-button>
      </div>
    </b-modal>

    <div class="studio-page-content">
      <j-detail v-if="tabSelected === 'detail'" />
      <j-assignment v-if="tabSelected === 'assignment'" />
      <j-log-activity v-if="tabSelected === 'log_activity'" />
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len */
import { mapState, mapActions } from 'vuex';
import { required, sameAs } from 'vuelidate/lib/validators';
import jTabs from '@/components/tabs/jTabs';
import jDetail from '@/views/user-employee/detail/jDetail';
import jAssignment from '@/views/user-employee/assignment/jAssignment';
import jLogActivity from '@/views/user-employee/log-activity/jLogActivity';
import PasswordChecker from '@/views/user-employee/partials/PasswordChecker';
import jMixEncryption from '@/mixins/jMixEncryption';

export default {
  name: 'JEmployee',
  components: {
    jDetail,
    jTabs,
    jAssignment,
    PasswordChecker,
    jLogActivity,
  },
  mixins: [jMixEncryption],
  validations: {
    form: {
      password: {
        required,
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
  data() {
    return {
      options: {
        // icon: 'fa-user',
        main_title: 'EMPLOYEE DETAIL',
        opt_title: '',
      },
      tabSelected: 'detail',
      tabs: [
        {
          idTab: 'tab-employee-detail', title: 'BASIC INFO', idComp: 'comp-employee-detail', comp: jDetail, isShow: true,
        },
        {
          idTab: 'tab-assignment', title: 'ASSIGNMENT', idComp: 'comp-assignment', comp: jAssignment, isShow: true, isActive: true,
        },
      ],
      is_loaded: false,
      configPopoverShow: false,
      form: {
        password: null,
        confirm_password: null,
      },
      showPassword: false,
      showConfirmPassword: false,
      isNotStrenghtPassword: false,
    };
  },
  computed: {
    ...mapState('jStoreEmployee', ['employee_detail', 'user_detail']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    passwordType() {
      if (this.showPassword) return 'text';
      return 'password';
    },
    confirmPasswordType() {
      if (this.showConfirmPassword) return 'text';
      return 'password';
    },
    confirmErrmessage() {
      if (!this.$v.form.password.required) {
        return 'Field is required';
      } else if (!this.$v.form.password.sameAsPassword) {
        return 'Confirm password is not match';
      }
      return 'Field is required';
    },
    generateData() {
      const dataSecMapp = [];
      this.user_detail.secretary_mode_mapping.forEach((val) => {
        dataSecMapp.push(val.id);
      });
      const genData = {
        id: this.user_detail.id,
        email: this.user_detail.email,
        employee_id: this.user_detail.employee_id,
        personal_email: this.user_detail.personal_email,
        password: this.user_detail.password ? this.user_detail.password : '',
        first_name: this.user_detail.first_name,
        last_name: this.user_detail.last_name ? this.user_detail.last_name : '',
        group_id: this.user_detail.teams ? this.user_detail.teams.id : 0,
        roles: this.user_detail.role_names ? this.user_detail.role_names.map(val => val.id) : [],
        user_role: this.user_detail.role ? this.user_detail.role.id : null,
        code: this.user_detail.code,
        join_date: this.user_detail.join_date,
        resign_date: this.user_detail.end_date,
        photo_url: this.user_detail.photo,
        phone_number: this.user_detail.phone_number,
        date_of_birth: this.user_detail.date_of_birth,
        place_of_birth: this.user_detail.place_of_birth,
        bank_account_name: this.user_detail.bank_name ? this.user_detail.bank_name.name : '',
        bank_account_number: this.user_detail.bank_account_number,
        bank_account_owner: this.user_detail.bank_account_holder_name,
        bank_account_branch: this.user_detail.bank_account_branch,
        contract_type: this.user_detail.employment_type ? this.user_detail.employment_type : '',
        type_of_contract: this.user_detail.contract_type ? this.user_detail.contract_type : '',
        active_reason: this.user_detail.active_reason ? this.user_detail.active_reason : '',
        non_active_reason: this.user_detail.nonactive_reason ? this.user_detail.nonactive_reason : '',
        secretary_mode: this.user_detail.secretary_mode,
        secretary_mode_list_team: dataSecMapp,
        country_id: this.user_detail.country ? this.user_detail.country.id : 0,
        employee_status: this.user_detail.employee_status ? 1 : 0,
        other_name: this.user_detail.other_name,
        gender: this.user_detail.gender,
        nationality_type: this.user_detail.nationality_type ? this.user_detail.nationality_type : null,
        identity_type: this.user_detail.id_type ? this.user_detail.id_type.text : '',
        passport_expired_date: this.user_detail.exp_date ? this.user_detail.exp_date : '',
        identity_no: this.user_detail.id_number,
        fax_number: 0,
        religion: this.user_detail.religion,
        marital_status: this.user_detail.marital_status,
        home_address: this.user_detail.home_address,
        postal_code: this.user_detail.postal_code,
        about: this.user_detail.notes,
        title: '',
        tax_identification_number: 0,
        bpjs_ketenagakerjaan: '',
        bpjs_kesehatan: '',
        ptkp: '',
        max_disbursed_count: 0,
        province_id: this.user_detail.province ? this.user_detail.province : '',
        city_id: this.user_detail.city ? this.user_detail.city : '',
        office_country_id: this.user_detail.office_country ? this.user_detail.office_country : '',
        office_province_id: this.user_detail.office_province ? this.user_detail.office_province : '',
        office_city_id: this.user_detail.office_city ? this.user_detail.office_city : '',
        contract_start_date: this.contract_start_date ? this.$moment(this.user_detail.contract_start_date).format('YYYY-MM-DD') : null,
        contract_end_date: this.contract_end_date ? this.$moment(this.user_detail.contract_end_date).format('YYYY-MM-DD') : null,
        location_id: this.user_detail.company_location ? this.user_detail.company_location : '',
        address: this.user_detail.address ? this.user_detail.address : '',
        office_address: this.user_detail.office_address ? this.user_detail.office_address : '',
        address_2: '',
        address_3: '',
        post_code: '',
        iban: '',
        managers: [],
        salutation: '',
        passport_no: '',
        passport_issuing: '',
        passport_issuing_date: '',
        passport_nationality: '',
        employment_type_id: this.user_detail.employment_type_id ? this.user_detail.employment_type_id : 0,
        employment_subtype_id: this.user_detail.employment_subtype_id ? this.user_detail.employment_subtype_id : 0,
      };
      return genData;
    },
    tabsShow() {
      return this.tabs.filter(i => i.isShow);
    },
    passwordCheckerData() {
      return {
        password: this.form.password,
        email: this.employee_detail ? this.employee_detail.email : '',
      };
    },
    tabOptions() {
      return [
        {
          id: 'detail',
          title: 'BASIC INFO',
          isShow: true,
        },
        {
          id: 'assignment',
          title: 'ASSIGNMENT',
          isShow: true,
        },
        {
          id: 'log_activity',
          title: 'LOG ACTIVITY',
          isShow: this.useConfigConcurrentLogin && this.isAdmin,
        },
      ];
    },
    useConfigConcurrentLogin() {
      return Number(process.env.RLS_CONCURRENT_LOGIN) === 1;
    },
    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },
  },
  methods: {
    ...mapActions('jStoreEmployee', ['changePasswordEmployee', 'deleteEmployee']),

    deletedEmployee() {
      const text = `Are you sure, want to delete ${this.employee_detail.first_name} ${this.employee_detail.last_name}`;

      this.$swal({
        title: 'Are you sure?',
        text,
        type: 'question',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.deleteEmployee({ user_company_ids: [this.$route.params.id] });
        }
      });
    },

    openModalchangePassword() {
      this.$refs.changePasswordModal.show();
      this.configPopoverShow = false;

      if (!this.publicKey) {
        this.setKeyPublicRSA();
      }
    },

    closeModalchangePassword() {
      this.$refs.changePasswordModal.hide();
      this.form = {
        password: null,
        confirm_password: null,
      };
    },

    async updatePassword() {
      this.$v.form.$touch();
      this.isNotStrenghtPassword = !this.$refs.passwordChecker.checkPasswordStrengh;
      if (!this.$v.form.$error && this.publicKey && !this.isNotStrenghtPassword) {
        const enctyptedConfirmPassword = await this.encryption(this.form.confirm_password);
        const enctyptedNewPassword = await this.encryption(this.form.password);
        const payload = {
          confirm_password: enctyptedConfirmPassword,
          new_password: enctyptedNewPassword,
          type: 'change-password',
          user_id: this.employee_detail.user_id,
        };
        this.$refs.changePasswordModal.hide();
        await this.changePasswordEmployee(payload);
      }
    },

    showTab(i) {
      this.$refs.tab.showTab(i);
    },
  },
};
</script>

<style lang="scss">
  .jTabsa {
    border-width: 0;
  }

  .img-employee {
    width: 44px;
    height: 44px;
    float: left;
    width: 40px;
    height: 40px;
    background-size: 40px;
    border: 2px solid;
    border-radius: 100%;
    padding: 2px;
    -o-object-fit: cover;
    object-fit: cover;
  }

  #tab-user .greedy-menu ul:first-of-type li a[aria-selected=true]{
    border: none !important;
    color: black !important;
    border-bottom: 5px solid rgb(22, 115, 207) !important;
  }

  #tab-user .link-tab a {
    text-transform: uppercase !important;
    font-weight: bold !important;
  }

  #tab-user .link-tab.router-link-active a {
    color: black;
    border-bottom: 5px solid rgb(22, 115, 207) !important;
  }

  #tab-user .greedy-menu {
    border: none !important;
    margin-bottom: 0;
  }

  .modal-change-password .modal-content {
    max-width: 650px;
  }

  .user-config-opt {
    padding: 5px;
    font-family: 'Poppins-Regular';
    font-size: 14px;
    cursor: pointer;
    margin-left: -5px;
    margin-right: -5px;
  }

  .user-config-opt:hover {
    background-color: #f2f2f2;
  }

  #employee-detail {
    .studio-page-header {
      height: 127px;
      padding-bottom: 0 !important
    }
  }

  #password-input,
  #confirm-password-input {
    position: relative;

    .showhide {
      position: absolute;
      top: 33px;
      right: 12px;
      font-size: 18px;
      cursor: pointer
    }

    .eye-error {
      margin-right: 20px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/user-employee/jEmployee.vue